"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const Radio_1 = __importStar(require("./Radio"));
const RadioGroup = props => {
    let initialSelected = '';
    const { valueSelected, defaultSelected, style, className, inline, onChange } = props, rest = __rest(props, ["valueSelected", "defaultSelected", "style", "className", "inline", "onChange"]);
    if (valueSelected !== undefined) {
        initialSelected = valueSelected;
    }
    else if (defaultSelected !== undefined) {
        initialSelected = defaultSelected;
    }
    const [selected, setSelected] = react_1.useState(initialSelected);
    react_1.useEffect(() => {
        if (valueSelected !== undefined) {
            setSelected(valueSelected);
        }
    }, [valueSelected]);
    const handleChange = react_1.useCallback((event, selectedItem) => {
        setSelected(selectedItem);
        if (onChange)
            onChange(event, selectedItem);
    }, [onChange]);
    const composedStyle = inline
        ? Object.assign(Object.assign({}, style), { display: 'flex', alignItems: 'baseline', flexWrap: 'wrap' }) : Object.assign({}, style);
    const options = react_1.default.Children.map(props.children, option => {
        const _a = option.props, { name, // eslint-disable-line no-unused-vars
        value, // eslint-disable-line no-unused-vars
        label, // eslint-disable-line no-unused-vars
        onCheck } = _a, // eslint-disable-line no-unused-vars
        other = __rest(_a, ["name", "value", "label", "onCheck"]);
        return option.type && option.type.displayName === Radio_1.RADIO_NAME
            ? (react_1.default.createElement(Radio_1.default, Object.assign({}, other, { name: props.name, key: option.props.value, value: option.props.value, label: option.props.label, onCheck: handleChange, checked: option.props.value === selected, style: Object.assign({ marginRight: '20px' }, option.props.style) })))
            : option;
    }, this);
    return (react_1.default.createElement("div", Object.assign({ style: composedStyle, className: className }, rest), options));
};
exports.default = RadioGroup;
RadioGroup.propTypes = {
    children: prop_types_1.default.node,
    className: prop_types_1.default.string,
    defaultSelected: prop_types_1.default.any,
    name: prop_types_1.default.string.isRequired,
    onChange: prop_types_1.default.func,
    style: react_style_proptype_1.default,
    inline: prop_types_1.default.bool,
    valueSelected: prop_types_1.default.any,
};
RadioGroup.defaultProps = {
    className: '',
    inline: false,
};
